import React from 'react';
import { getTranslations } from '../translations';
import NotFound from '../components/NotFound';

export default () => {
  const { error_messages: { "404": translations } } = getTranslations();
  
  return (
    <NotFound
      header={translations.header}
      subhead={translations.subhead}
      copy={translations.cta} />
  );
};
